import axios from "axios"
import Axios from "axios"
import { baseUrl } from "../assets/Animations"

export const createStudentWorkflowFunction = (userName) => {
    let todaysDate = new Date()
    let theMonth = ''
    let todaysMonth = todaysDate.getMonth() + 1
    if(todaysMonth < 10) {
        theMonth = `0${todaysMonth}`
    } else {
        theMonth = todaysMonth
    }
    return(
        {
            todoId: Math.random().toString(16).slice(2),
            todoName: "Name",
            todoDescription: "Change name of card to students name.",
            instrumentList: [],
            teacherList: [],
            todoDueDate: `${todaysDate.getFullYear()}-${theMonth}-${todaysDate.getDate()}T10:00:00`,
            todoAlarm: false,
            whichSchool: 'all',
            todoOwner: userName.split(' ')[0],
            whichList: 'student',
            todoSubtasks: [
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Change name on card',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: []
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Check with teacher',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: `Check availability in portal`,
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Email teacher(s)',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: `If no response by ${theMonth}/${todaysDate.getDate() + 2} have Courtney call family`,
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: `Receive confirmation of call from Courtney`,
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Schedule 1st Lesson',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure teacher\'s background check has cleared',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Send "New Student Info" email to teacher',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: []
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Create Calendar Event',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Paste (new student info) into notes',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure there is a * (if it is an intro lessons price)',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make recurring',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If virtual: Add video link / invitations',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If NOT virtual: Remove Video Link',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: '"Intro Lesson Confirmation" email',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Edit Email',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Input teacher info',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Receive Confirmations',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If > 1 week away: set task to set reminders (48hrs before)',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Teacher confirmed',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Student confirmed',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Courtney Follow Up After Intro',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Call the family & leave a message',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If they answer create phone log',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If NO answer send a check-in email',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Call the teacher',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Mark Student as Called to pass card',
                        } 
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Complete entry in student database',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: []
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: '"Checking In" email (day after lesson)',
                    subtaskDescription: 'Intro Lesson: Last Name',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Check with Courtney about what Teacher said',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Set task to send day after lesson: _____',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'If Continuing...',
                    subtaskDescription: 'Confirm lesson with teacher and student 2 days prior. *Only if scheduled more than a week out*',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Switch to "Active" in database',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure recurring (no symbol starting following week)',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Send "Continuing Lessons" Email',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Tell teacher',
                        },
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'If Not Continuing...',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Do they want to try another teacher?',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If yes: create "old student onboarding"',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If no: "we understand" / they will be billed at end of month',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Tell Teacher',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure event is not recurring',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Switch to "left the school" in database',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'One Month Check-in',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Create "one month checking" flow from template',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Set date: 1 month after first lesson',
                        }
                    ]
                }
            ]
        }
    )  
}



export const createStudentWorkflowFunction2022 = (userName) => {
    let todaysDate = new Date()
    let theMonth = ''
    let todaysMonth = todaysDate.getMonth() + 1
    if(todaysMonth < 10) {
        theMonth = `0${todaysMonth}`
    } else {
        theMonth = todaysMonth
    }
    return(
        {
            todoId: Math.random().toString(16).slice(2),
            todoName: "Name",
            todoDescription: "Change name of card to students name.",
            familyId: '',
            studentList: [],
            todoDueDate: `${todaysDate.getFullYear()}-${theMonth}-${todaysDate.getDate()}T10:00:00`,
            todoAlarm: false,
            whichSchool: 'all',
            todoOwner: userName.split(' ')[0],
            whichList: 'student',
            todoSubtasks: [
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Change name on card',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: []
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Check with teacher',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: `Check availability in portal`,
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Email teacher(s)',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: `If no response by ${theMonth}/${todaysDate.getDate() + 2} have Courtney call family`,
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: `Receive confirmation of call from Courtney`,
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Schedule 1st Lesson',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure teacher\'s background check has cleared',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Send "New Student Info" email to teacher',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: []
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Create Calendar Event',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Paste (new student info) into notes',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure there is a * (if it is an intro lessons price)',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make recurring',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If virtual: Add video link / invitations',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If NOT virtual: Remove Video Link',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: '"Intro Lesson Confirmation" email',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Edit Email',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Input teacher info',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Receive Confirmations',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If > 1 week away: set task to set reminders (48hrs before)',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Teacher confirmed',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Student confirmed',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Courtney Follow Up After Intro',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Call the family & leave a message',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If they answer create phone log',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If NO answer send a check-in email',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Call the teacher',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Mark Student as Called to pass card',
                        } 
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Complete entry in student database',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: []
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: '"Checking In" email (day after lesson)',
                    subtaskDescription: 'Intro Lesson: Last Name',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Check with Courtney about what Teacher said',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Set task to send day after lesson: _____',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'If Continuing...',
                    subtaskDescription: 'Confirm lesson with teacher and student 2 days prior. *Only if scheduled more than a week out*',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Switch to "Active" in database',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure recurring (no symbol starting following week)',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Send "Continuing Lessons" Email',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Tell teacher',
                        },
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'If Not Continuing...',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Do they want to try another teacher?',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If yes: create "old student onboarding"',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If no: "we understand" / they will be billed at end of month',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Tell Teacher',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure event is not recurring',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Switch to "left the school" in database',
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'One Month Check-in',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Create "one month checking" flow from template',
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Set date: 1 month after first lesson',
                        }
                    ]
                }
            ]
        }
    )  
}




export const createStudentOnboardingWorkflowForNewStudentForm = (newStudent, callback) => {
    let todaysDate = new Date()
    let theMonth = ''
    let todaysMonth = todaysDate.getMonth() + 1
    if(todaysMonth < 10) {
        theMonth = `0${todaysMonth}`
    } else {
        theMonth = todaysMonth
    }

    let instrumentArray = [] 
    for(let i = 0; i < newStudent.students.length; i++) {
        for(let j = 0; j < newStudent.students[i].instrumentList.length; j++) {
            instrumentArray.push(newStudent.students[i].instrumentList[j])
        }
    }

    let newTodo = {
            todoId: Math.random().toString(16).slice(2),
            todoName: `${newStudent.familyName}`,
            todoDescription: "Change name of card to students name.",
            instrumentList: instrumentArray,
            teacherList: [],
            todoDueDate: `${todaysDate.getFullYear()}-${theMonth}-${todaysDate.getDate()}T10:00:00`,
            todoAlarm: false,
            whichSchool: newStudent.school.toLowerCase(),
            todoOwner: 'Everyone',
            whichList: 'student',
            todoSubtasks: [
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Assign Task to Yourself',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: []
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Check with teacher',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: `Check availability in portal`,
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Email teacher(s)',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: `If no response by ${theMonth}/${todaysDate.getDate() + 2} have Courtney call family`,
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: `Receive confirmation of call from Courtney`,
                            subtask2xCompleted: false
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Schedule 1st Lesson',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure teacher\'s background check has cleared',
                            subtask2xCompleted: false
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Send "New Student Info" email to teacher',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: []
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Create Calendar Event',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Paste (new student info) into notes',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure there is a * (if it is an intro lessons price)',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make recurring',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If virtual: Add video link / invitations',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If NOT virtual: Remove Video Link',
                            subtask2xCompleted: false
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: '"Intro Lesson Confirmation" email',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Edit Email',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Input teacher info',
                            subtask2xCompleted: false
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Receive Confirmations',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If > 1 week away: set task to set reminders (48hrs before)',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Teacher confirmed',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Student confirmed',
                            subtask2xCompleted: false
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Courtney Follow Up After Intro',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Call the family & leave a message',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If they answer create phone log',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If NO answer send a check-in email',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Call the teacher',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Mark Student as Called to pass card',
                            subtask2xCompleted: false
                        } 
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'Complete entry in student database',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: []
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: '"Checking In" email (day after lesson)',
                    subtaskDescription: 'Intro Lesson: Last Name',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Check with Courtney about what Teacher said',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Set task to send day after lesson: _____',
                            subtask2xCompleted: false
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'If Continuing...',
                    subtaskDescription: 'Confirm lesson with teacher and student 2 days prior. *Only if scheduled more than a week out*',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Switch to "Active" in database',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure recurring (no symbol starting following week)',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Send "Continuing Lessons" Email',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Tell teacher',
                            subtask2xCompleted: false
                        },
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'If Not Continuing...',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Do they want to try another teacher?',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If yes: create "old student onboarding"',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'If no: "we understand" / they will be billed at end of month',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Tell Teacher',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Make sure event is not recurring',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Switch to "left the school" in database',
                            subtask2xCompleted: false
                        }
                    ]
                },
                {
                    subtaskId: Math.random().toString(16).slice(2),
                    subtaskName: 'One Month Check-in',
                    subtaskDescription: '',
                    subtaskDueDate: new Date(),
                    subtaskAlarm: false,
                    subtaskSubtasks: [
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Create "one month checking" flow from template',
                            subtask2xCompleted: false
                        },
                        {
                            subtask2xId: Math.random().toString(16).slice(2),
                            subtask2xName: 'Set date: 1 month after first lesson',
                            subtask2xCompleted: false
                        }
                    ]
                }
            ]
        }
 
    Axios.post(`${baseUrl}/onboarding`, {
        todoId: newTodo.todoId,
        todoName: newTodo.todoName,
        todoDescription: newTodo.todoDescription,
        instrumentList: newTodo.instrumentList,
        teacherList: newTodo.teacherList,
        todoDueDate: newTodo.todoDueDate,
        todoAlarm: newTodo.todoAlarm,
        todoOwner: newTodo.todoOwner,
        whichList: newTodo.whichList,
        whichSchool: newTodo.whichSchool,
        todoSubtasks: newTodo.todoSubtasks
    })
    .then((response) => {
        if(callback) {
            callback(response.data)
        }
    })
    .catch((err) => {
        console.log(err)
    })
}



//_______________________________NEW FALL 2022 STUDENT ONBOARDING CARD__________________________

export const createStudentOnboardingCard2022FromNewStudentForm = async (newStudent, callback) => {
    let todaysDate = new Date()
    let theMonth = ''
    let todaysMonth = todaysDate.getMonth() + 1
    if(todaysMonth < 10) {
        theMonth = `0${todaysMonth}`
    } else {
        theMonth = todaysMonth
    }

    let studentArray = [] 
    for(let i = 0; i < newStudent.students.length; i++) {
        let currentStudent = {
            studentId: newStudent.students[i].studentId,
            studentName: newStudent.students[i].studentName,
            instrumentList: [],
            teacherList: [],
            introLesson: {
                date: '',
                isScheduled: false,
                hasBeenCalled: false
            }
        }
        for(let j = 0; j < newStudent.students[i].instrumentList.length; j++) {
            currentStudent.instrumentList.push(newStudent.students[i].instrumentList[j])
        }
        studentArray.push(currentStudent)
    }

    Axios.get(`${baseUrl}/studentworkflowtemplates/86310799471e2`)
    .then((res) => {
        //console.log(templateWorfklow)
        let newTodo = {
                todoId: Math.random().toString(16).slice(2),
                todoName: `${newStudent.familyName}`,
                todoDescription: "Change name of card to students name.",
                familyId: `${newStudent.familyId}`,
                studentList: studentArray,
                todoDueDate: `${todaysDate.getFullYear()}-${theMonth}-${todaysDate.getDate()}T10:00:00`,
                todoAlarm: false,
                theyHaveBeenCalled: false,
                whichSchool: newStudent.school.toLowerCase(),
                todoOwner: 'Everyone',
                whichList: 'student',
                todoSubtasks: res.data.todoSubtasks
            }
     
        Axios.post(`${baseUrl}/student-onboarding`, {
            todoId: newTodo.todoId,
            todoName: newTodo.todoName,
            todoDescription: newTodo.todoDescription,
            studentList: newTodo.studentList,
            todoDueDate: newTodo.todoDueDate,
            todoAlarm: newTodo.todoAlarm,
            theyHaveBeenCalled: newTodo.theyHaveBeenCalled,
            todoOwner: newTodo.todoOwner,
            whichList: newTodo.whichList,
            whichSchool: newTodo.whichSchool,
            todoSubtasks: newTodo.todoSubtasks
        })
        .then((response) => {
            if(callback) {
                callback(response.data)
            }
        })
        .catch((err) => {
            console.log(err)
        })
    })
    .catch((err) => {
        console.log(err)
    })
}


//____________________________________________________




export const createPostInterviewTask = async (theFirstName, theLastName, theRefs, theSchool, theInstruments, callback) => {
    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }
    let schoolabr = ''
    let schoolValueAbbreviation = ''
    if(theSchool === "Great Lakes Music Academy") {
        schoolabr = "GLMA"
        schoolValueAbbreviation = "glma"
    } else if (theSchool === "Lakeside Music Academy") {
        schoolabr = "LSMA"
        schoolValueAbbreviation = "lsma"
    } else if (theSchool === "Treeside Music Academy") {
        schoolabr = "TSMA"
        schoolValueAbbreviation = "tma"
    } else if (theSchool === "Mountainside Music Academy") {
        schoolabr = "MMA"
        schoolValueAbbreviation = "mma"
    } else if (theSchool === "Parkside Music Academy") {
        schoolabr = "PSMA"
        schoolValueAbbreviation = "psma"
    } else if (theSchool === "Morningside Music Academy") {
        schoolabr = "MOR"
        schoolValueAbbreviation = "mor"
    }  else if (theSchool === "Denton Music Academy") {
        schoolabr = "DEN"
        schoolValueAbbreviation = "den"
    }  else if (theSchool === "Tempe Music Academy") {
        schoolabr = "TEM"
        schoolValueAbbreviation = "tem"
    }  else if (theSchool === "Tulsa Music Academy") {
        schoolabr = "TUL"
        schoolValueAbbreviation = "tul"
    } else {
        schoolabr = "-"
        schoolValueAbbreviation = ""
    }
    let instrumentNames = ''
    for(let i = 0; i < theInstruments.length; i++) {
        instrumentNames = instrumentNames + `${theInstruments[i].name} `
    }
    let todaysDate = new Date()
    let theMonth = ''
    let todaysMonth = todaysDate.getMonth() + 1
    if(todaysMonth < 10) {
        theMonth = `0${todaysMonth}`
    } else {
        theMonth = todaysMonth
    }
    let newTodo = {
        todoId: Math.random().toString(16).slice(2),
        todoName: `${theFirstName} ${theLastName}: Interview | ${schoolabr}`,
        todoDescription: `References: ${theRefs} || Instruments: ${instrumentNames}`,
        instrumentList: theInstruments,
        teacherList: [],
        todoDueDate: `${todaysDate.getFullYear()}-${theMonth}-${todaysDate.getDate()}T10:00:00`,
        todoAlarm: false,
        todoOwner: 'Courtney',
        whichList: 'move-forward',
        whichSchool: schoolValueAbbreviation,
        todoSubtasks: [
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Interview',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Make sure it gets scheduled',
                        subtask2xCompleted: false
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Send "Interview Confirmation" Email',
                        subtask2xCompleted: false
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Perform Interview',
                        subtask2xCompleted: false
                    },
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Call References if necessary (in task notes)',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: []
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Make a decision',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Yes: Create "Onboard Teacher" Card',
                        subtask2xCompleted: false
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'No: Send "Your Application" Email',
                        subtask2xCompleted: false
                    },
                ]
            }
        ]
    }
    Axios.post(`${baseUrl}/onboarding`, {
        todoId: newTodo.todoId,
        todoName: newTodo.todoName,
        todoDescription: newTodo.todoDescription,
        todoDueDate: newTodo.todoDueDate,
        todoAlarm: newTodo.todoAlarm,
        todoOwner: newTodo.todoOwner,
        whichList: newTodo.whichList,
        whichSchool: newTodo.whichSchool,
        todoSubtasks: newTodo.todoSubtasks
    }, myHeader)
    .then((response) => {
        if(callback) {
            callback(response.data)
        }
    })
    .catch((err) => {
        console.log(err)
    })
}




export const createTeacherOnboardingWorkflow = (setLoading, callback, setOpenWorkflowModal2023) => {
    setLoading('Creating Workflow')
    let myToken = localStorage.getItem('token')
    let myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }
    let newWorkflow = {}
    let todaysDate = new Date()
    let theMonth = ''
    let todaysMonth = todaysDate.getMonth() + 1
    if(todaysMonth < 10) {
        theMonth = `0${todaysMonth}`
    } else {
        theMonth = todaysMonth
    }
    newWorkflow = {
        todoId: Math.random().toString(16).slice(2),
        todoName: "[Name]: Teacher Onboarding",
        todoDescription: "Change name of card to teachers name.",
        todoDueDate: `${todaysDate.getFullYear()}-${theMonth}-${todaysDate.getDate()}T10:00:00`,
        todoAlarm: false,
        todoOwner: 'Courtney',
        whichList: 'teacher',
        todoSubtasks: [
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Job Offer Email',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Send'
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Receive response'
                    }
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Welcome Email',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Send'
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Receive response with attachments'
                    }
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Create Calendar',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Correct Account / Correct Timezone!'
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Get sharable link (Copy into "Your calendar" email)'
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Share with teacher / "Make changes and manage sharing"'
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Copy Calendar ID (for database)'
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Create "Test" for next day'
                    }
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Pandadoc',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'In correct account!!!',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Documents/duplicates',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Rename the duplicate',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Add a recipient -add teacher\'s details',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Send documents/share via link',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: '"Assign All" to teacher',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Generate Link / Copy teacher\'s link into email',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'You will be prompted to sign',
                    }
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: '"Your Calendar..." email',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Make sure all names/links are replaced and correct',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Send',
                    }
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Add to teacher database',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Picture: crop (square), rename, edit w/ google photos if ugly',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Bio: read, edit if stupid',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Input all info',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'If it says pic is too big use compressor.io',
                    }
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Set Up Video Call for Onboarding w/ Handbook',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Confirm Video Call',
                    }
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Email Prescott & Bri Teacher Info For Welcome Email',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: []
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Confirm...',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Paperwork is complete',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Availability is filled out',
                    }
                ]
            }
        ]
    }
    Axios.post(`${baseUrl}/onboarding`, {
        todoId: newWorkflow.todoId,
        todoName: newWorkflow.todoName,
        todoDescription: newWorkflow.todoDescription,
        instrumentList: newWorkflow.instrumentList ? newWorkflow.instrumentList : [],
        teacherList: newWorkflow.teacherList ? newWorkflow.teacherList : [],
        todoDueDate: newWorkflow.todoDueDate,
        todoAlarm: newWorkflow.todoAlarm,
        todoOwner: newWorkflow.todoOwner,
        whichList: newWorkflow.whichList,
        whichSchool: newWorkflow.whichSchool,
        todoSubtasks: newWorkflow.todoSubtasks
    }, myHeader)
    .then((response) => {
        callback(response.data)
        setOpenWorkflowModal2023(response.data)
        setLoading(false)
    })
    .catch((e) => {
        //setError({message: e.response.data, status: e.response.status})
        setLoading(false)
    })
}

export const createTeacherOffboardingWorkflow = (setLoading, callback, setOpenWorkflowModal2023) => {
    setLoading('Creating Workflow')
    let myToken = localStorage.getItem('token')
    let myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }
    let newWorkflow = {}
    let todaysDate = new Date()
    let theMonth = ''
    let todaysMonth = todaysDate.getMonth() + 1
    if(todaysMonth < 10) {
        theMonth = `0${todaysMonth}`
    } else {
        theMonth = todaysMonth
    }
    newWorkflow = {
        todoId: Math.random().toString(16).slice(2),
        todoName: "[Name]: Teacher Offboarding",
        todoDescription: "Change name of card to teachers name.",
        todoDueDate: `${todaysDate.getFullYear()}-${theMonth}-${todaysDate.getDate()}T10:00:00`,
        todoAlarm: false,
        todoOwner: 'Courtney',
        whichList: 'offboarding',
        whichSchool: 'all',
        todoSubtasks: [
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Set teacher to leaving in database',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: []
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Make sure teacher does not inform family',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: []
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Put up hiring post on Indeed',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: []
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Notify Bri about teacher leaving',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: []
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Has the teacher given one month notice?',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'If not, try to get them to stay at least one month',
                    }
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Set their last day in database',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: []
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Delete future lessons out of the teacher\'s calendar',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: []
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Send "Leaving Remarks" email to teacher',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: [
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Receive reply',
                    },
                    {
                        subtask2xId: Math.random().toString(16).slice(2),
                        subtask2xName: 'Ask for recommendations to fill their position',
                    }
                ]
            },
            {
                subtaskId: Math.random().toString(16).slice(2),
                subtaskName: 'Have final offboarding call',
                subtaskDescription: '',
                subtaskDueDate: new Date(),
                subtaskAlarm: false,
                subtaskSubtasks: []
            }
        ]
    }
    Axios.post(`${baseUrl}/teacher-onboarding`, {
        todoId: newWorkflow.todoId,
        todoName: newWorkflow.todoName,
        todoDescription: newWorkflow.todoDescription,
        applicationId: '',
        instrumentList: newWorkflow.instrumentList ? newWorkflow.instrumentList : [],
        theyHaveBeenCalled: false,
        todoDueDate: newWorkflow.todoDueDate,
        todoAlarm: newWorkflow.todoAlarm,
        todoOwner: newWorkflow.todoOwner,
        whichList: newWorkflow.whichList,
        whichSchool: newWorkflow.whichSchool,
        todoSubtasks: newWorkflow.todoSubtasks
    }, myHeader)
    .then((response) => {
        callback(response.data)
        setOpenWorkflowModal2023(response.data)
        setLoading(false)
    })
    .catch((e) => {
        //setError({message: e.response.data, status: e.response.status})
        setLoading(false)
    })
}